import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import CardList from "./CardList";
import Card from "./Card";


const products = [{
    "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
    "img": "./assets/sample-image/1420-w320h320.png",
    "price": "2,370,000 ",
    "color_range_1": "#192B3B",
    "color_range_2": "#F5F8FA",
    "color_range_3": "#1473E6",
    "link_product": "/singlePage",
    "type_card": "gold",
    "id": 1_0000,
    "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
    "star": 4,
    "total_score": 128
}, {
    "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
    "img": "./assets/sample-image/1420-w320h320.png",
    "color_range_1": "#192B3B",
    "color_range_2": "#F5F8FA",
    "color_range_3": "#1473E6",
    "link_product": "/singlePage",
    "type_card": "out-of-stock",
    "id": 2_000000,
    "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
    "star": 4,
    "total_score": 128
}, {
    "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
    "img": "./assets/sample-image/1420-w320h320.png",
    "price": "۲،۷۶۰،۰۰۰ ",
    "discount": "2,760,008 ",
    "color_range_1": "#192B3B",
    "color_range_2": "#F5F8FA",
    "color_range_3": "#1473E6",
    "link_product": "/singlePage",
    "type_card": "purple",
    "id": 3_00000,
    "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
    "star": 3,
    "total_score": 128
},
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "/singlePage",
        "type_card": "blue",
        "id": 3_000,
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 2,
        "total_score": 128
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "/singlePage",
        "type_card": "blue",
        "id": 3_00,
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 1,
        "total_score": 128
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "/singlePage",
        "type_card": "out-of-stock",
        "id": 3_52,
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 0,
        "total_score": 128
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "/singlePage",
        "type_card": "blue",
        "id": 3_77,
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 5,
        "total_score": 128
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "/singlePage",
        "type_card": "blue",
        "id": 3_1,
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 4,
        "total_score": 128
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "/singlePage",
        "type_card": "blue",
        "id": 3_2,
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 2,
        "total_score": 128
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "/singlePage",
        "type_card": "blue",
        "id": 3_5,
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 4,
        "total_score": 128
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "/singlePage",
        "type_card": "blue",
        "id": 3_9,
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 1,
        "total_score": 128
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "/singlePage",
        "type_card": "blue",
        "id": 3_8,
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 5,
        "total_score": 128
    },]
const ProductCardList = () => {
    return (
        <div className="products-card">
            <div id="type-card-products" className="row xpb-16">
                {products && products.map((product) => (
                    <div className="col-6 col-lg-4 col-xl-4 col-xxl-3" key={product.id}>
                        <div className="box-cards">
                            <Card product={product}/>
                        </div>
                    </div>
                ))}
            </div>
            <div className="pagination-wrapper d-flex justify-content-center align-content-center xpb-25">
                <nav aria-label="Page navigation example">
                    <ul className="pagination persian-number xm-0">
                        <li className="page-item active"><a className="page-link" href="#">1</a></li>
                        <li className="page-item"><a className="page-link" href="#">2</a></li>
                        <li className="page-item"><a className="page-link" href="#">3</a></li>
                        <li className="page-item">
                            <a className="page-link" href="#" aria-label="Next">
                                <span aria-hidden="true"><IconName name="last_page" className="icon"/></span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
};

export default ProductCardList;
